import React from "react";

import { useSelector } from "react-redux";
import { getMessageType } from "../../redux/feature/panelMessage/panelMessage-slice";
import { getPanelMessages } from "../../utils/constants/panelMessage";
import { MessagePanel, MessagePanelProps } from "./ConfirmationModal";
import HeaderPanel from "./HeaderPanel";

export type CopyCutPasteMessagePanelProps = MessagePanelProps & { title: string };

export const CopyCutPasteMessagePanel = () => {
  const messageType = useSelector(getMessageType);

  if (!messageType) return null;

  const { title, ...objData } = getPanelMessages()[messageType];
  //  style={{ zIndex: "unset", marginTop: "20vh", height: "auto", position: "unset" }}
  return (
    <>
      {title && <HeaderPanel applyPadding>{title}</HeaderPanel>}
      <MessagePanel {...objData} messageType={messageType} />
    </>
  );
};
